import React from "react";
import "./Features.css";

const Features = () => {
  return (
    <section className="features-section">
      <div className="features-container">
        <h2 className="features-title">App Features</h2>
        <div className="features-list">
          <div className="feature-item">
            <img
              src={"assets/images/embedded-video.png"}
              style={{ borderRadius: "50%" }}
              alt="Video Embedding"
              loading="lazy"
              className="feature-image"
            />
            <h3 className="feature-title">Video Embedding</h3>
            <p className="feature-description">
              Easily embed your YouTube videos through our app to gain valuable
              watch time and enhance your channel's growth.
            </p>
          </div>
          <div className="feature-item">
            <img
              src={"assets/images/growth.png"}
              alt="Watch Time Accumulation"
              className="feature-image"
              loading="lazy"
              style={{
                objectFit: "contain",
                borderRadius: "0px 0px 20px 60px",
              }}
            />
            <h3 className="feature-title">Watch Time Accumulation</h3>
            <p className="feature-description">
              Accumulate watch time effectively by having your videos viewed by
              others on our platform, helping you reach your milestones faster.
            </p>
          </div>
          <div className="feature-item">
            <img
              src={"assets/images/dashboard.png"}
              alt="User-Friendly Dashboard"
              loading="lazy"
              className="feature-image"
            />
            <h3 className="feature-title">User-Friendly Dashboard</h3>
            <p className="feature-description">
              Access an intuitive dashboard to track your video performance,
              watch time, and overall progress.
            </p>
          </div>
          <div className="feature-item">
            <img
              src={"assets/images/like.png"}
              style={{ objectFit: "scale-down", borderRadius: "70px" }}
              alt="Simple Integration"
              loading="lazy"
              className="feature-image"
            />
            <h3 className="feature-title">Designed for Ease & Efficiency</h3>
            <p className="feature-description">
              GrowTube features an intuitive and stylish interface, making it
              easy to use. Quickly link your YouTube channel and embed videos
              with just a few clicks.
            </p>
          </div>
          <div className="feature-item">
            <img
              src={"assets/images/plans.png"}
              alt="Subscription Plans"
              className="feature-image"
              loading="lazy"
            />
            <h3 className="feature-title">Subscription Plans</h3>
            <p className="feature-description">
              Future plans will include subscription options for additional
              features like embedding more videos and enjoying an ad-free
              experience.
            </p>
          </div>
          <div className="feature-item">
            <img
              src={"assets/images/performance_optimisation.png"}
              alt="Performance Enhancements"
              className="feature-image"
              loading="lazy"
              style={{ objectFit: "contain" }}
            />
            <h3 className="feature-title">Performance Enhancements</h3>
            <p className="feature-description">
              We are committed to continuous improvements, including bug fixes
              and performance enhancements based on user feedback.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
